<template>
  <v-container fluid>
    <v-dialog v-model="visible" persistent max-width="540px">
      <v-card id="import_credentials_root">
        <v-card-title>
          {{ startPage ? $t('importCredential.title') : $t('importCredential.externalProviderCredentialsTitle', { providerName: selectedProvider.displayName }) }}
        </v-card-title>

        <v-tabs
          v-model="tab" class="pt-6 d-none"
          background-color="transparent"
          color="black"
          centered
          hide-slider
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#providers">
          </v-tab>

          <v-tab href="#credentials">
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="pt-6">
          <v-tab-item :key="1" value="providers" :transition="false">
            <v-card flat>
              <v-card-text class="text-center">
              </v-card-text>
              <v-row no-gutters class="ml-6 mr-6 mb-3 mb-0 pb-0">
                <v-col class="d-flex align-left mb-0 pb-0">
                  <v-select
                    id="selectedProvider"
                    v-model="selectedProvider"
                    :items="providers"
                    item-text="displayName"
                    :return-object="true"
                    :label="$t('importCredential.selectProvider')"
                    chips
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters class="ml-6 mr-6 mt-0 pt-0">
                <v-col class="d-flex align-left" cols="auto">
                  <v-icon>mdi-information-outline</v-icon>
                </v-col>
                <v-col class="pl-3">
                  <span>{{ $t('importCredential.externalProviderExplainer') }} </span>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="2" value="credentials" :transition="false">
            <v-card flat>
              <v-card-text class="text-center">
                <v-list>
                  <v-list-item v-for="item in credentialsInfoArray" :key="item.id">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-checkbox :id="item.description" v-model="selectedCredentials" :label="item.description" :value="item.id" />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-card-actions class="mt-3">
          <v-btn v-if="!startPage" class="v-btn-back" @click="backClick">
            {{ $t('main.back') }}
          </v-btn>
          <v-btn id="cancel_button" class="v-btn-back" @click="back()">{{ $t('main.cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn id="credential_provider_login" color="primary" class="v-btn-done text-center" :disabled="!selectedProvider" @click="doneClick">
            {{ startPage ? nextButtonText : $t('importCredential.import') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmationDialog ref="confirmDialog" />
  </v-container>
</template>

<script>
import csc from '../services/api/csc'
import credentialRefs from '../services/api/credentialRefs'
import eventBus, { showToastSuccess, showToastError } from '../event-bus'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'

export default {
  name: 'ImportCredential',
  components: { ConfirmationDialog },
  data() {
    return {
      visible: true,
      startPage: true,
      tab: 'providers',
      providers: [],
      selectedCredentials: [],
      credentialsInfoArray: [],
      selectedProvider: undefined,
      selectedCredential: undefined,
      id_token: undefined,
      alreadyLoggedProviderId: null,
      externalProviderLoggedIn: false,
      logoutConfirmation: false,
      credentialList: [],
      clientName: 'web',
      popupLoginWidth: this.$store.state.remoteConfig.popupLogin?.width ?? 770,
      popupLoginHeight: this.$store.state.remoteConfig.popupLogin?.height ?? 720
    }
  },
  computed: {
    nextButtonText() {
      if (this.alreadyLoggedProviderId) {
        return this.selectedProvider && (this.selectedProvider.id === this.alreadyLoggedProviderId) ? this.$t('main.next') : this.$t('importCredential.login')
      } else {
        return this.$t('importCredential.login')
      }
    }
  },
  /* watch: {
    async selectedProvider(val, oldVal) {
    }
  }, */
  async mounted() {
    this.providers = await credentialRefs.getExternalProviders(this.clientName)
    if (this.providers?.length > 0) {
      const user = await this.$popupAuth.getUser()
      try {
        this.id_token = user ? await this.$popupAuth.getIdToken() : null
        // this.id_token = user ? user.id_token : null
        if (user && !this.id_token) {
          // this.id_token = user.access_token
          this.id_token = await this.$popupAuth.getAccessToken()
        }
      } catch (Err) {
        this.id_token = null
      }
      this.externalProviderLoggedIn = this.id_token != null
      if (this.id_token) {
        this.alreadyLoggedProviderId = this.externalProviderLoggedIn ? this.$store.state.externalProvider?.providerId : null
        if (this.alreadyLoggedProviderId) {
          this.selectedProvider = this.getProviderById(this.alreadyLoggedProviderId)
        }
      } else {
        this.selectedProvider = null
        this.alreadyLoggedProviderId = null
      }
    }
  },
  methods: {
    backToParent(e) {
      if (!e) {
        this.$router.go(-1)
      }
    },
    backClick() {
      this.startPage = true
      this.tab = 'providers'
      this.selectedCredentials = []
      this.credentialsInfoArray = []
    },
    nextClick() {
      this.startPage = false
      this.tab = 'credentials'
    },

    back() {
      this.$router.go(-1)
    },

    getProviderById(id) {
      return this.providers.find(provider => provider.id === id)
    },

    getExternalProviderRDSSBaseURL(providerId) {
      return this.$store.state.remoteConfig.rdssApiUrl + '/v1/extproviders/' + providerId
    },

    handleCSCErrorMessage(error) {
      if (error.message) {
        return this.$t('toastMessage.errorDuringPopupLoginWithDetails', { msg: error.message })
      } else {
        return this.$t('toastMessage.errorDuringPopupLogin')
      }
    },

    async logoutExternalProvider() {
      await this.$popupAuth.logout()
      this.alreadyLoggedProviderId = null
    },

    async doneClick(e) {
      if (this.startPage) {
        if (!this.selectedProvider) {
          showToastError(this.$t('importCredential.selectProviderFirst'))
          return
        }
        const usedOIDC = this.selectedProvider.oidc

        let providerBaseURL

        if (usedOIDC.authorizationEndpoint && usedOIDC.tokenEndpoint && usedOIDC.revocationEndpoint) {
          providerBaseURL = this.getExternalProviderRDSSBaseURL(this.selectedProvider.id)
        } else {
          providerBaseURL = this.selectedProvider.apiBaseUrl
        }

        if (this.selectedProvider.id !== this.alreadyLoggedProviderId) {
          if (this.alreadyLoggedProviderId) {
            const userConfirmed = await this.$refs.confirmDialog.openDialog({
              title: this.$t('dialog.externalproviderAlreadyLoggedLogoutConfirmation.title'),
              message: this.$t('dialog.externalproviderAlreadyLoggedLogoutConfirmation.description'),
              yesText: this.$t('main.yes'),
              noText: this.$t('main.no')
            })

            // Handle the response
            if (userConfirmed) {
              await this.logoutExternalProvider()
            } else {
              return
            }
          }

          const settings = {
            authority: usedOIDC.issuer,
            apiBaseUrl: this.selectedProvider.apiBaseUrl,
            providerId: this.selectedProvider.id,
            client_id: usedOIDC.clientId,
            response_type: 'code',
            scope: usedOIDC.scope,
            prompt: usedOIDC.prompt,
            // extraQueryParams: oidcConfig.extraQueryParams,
            monitorSession: false,
            // popupWindowFeatures: `location=no,toolbar=no,width=${this.popupLoginWidth},height=${this.popupLoginHeight},left=100,top=100`
            popupWindowFeatures: {
              location: false,
              menubar: false,
              toolbar: false,
              height: this.popupLoginHeight,
              width: this.popupLoginWidth,
              closePopupWindowAfterInSeconds: -1
            }
          }
          if (usedOIDC.clientSecret) {
            settings.client_secret = usedOIDC.clientSecret
          }

          if (usedOIDC.authorizationEndpoint && usedOIDC.tokenEndpoint && usedOIDC.revocationEndpoint) {
            settings.metadata = {
              authorization_endpoint: usedOIDC.authorizationEndpoint,
              // token_endpoint: usedOIDC.tokenEndpoint,
              token_endpoint: providerBaseURL + '/openid/token',
              revocation_endpoint: usedOIDC.revocationEndpoint
            }
          }

          this.$popupAuth.setSettings(settings)
          try {
            const user = await this.$popupAuth.login()
            this.id_token = user.id_token
            if (!user.id_token) {
              this.id_token = user.access_token
            }
            this.alreadyLoggedProviderId = this.selectedProvider.id
            // this.externalProviderLoggedIn = this.id_token != null
          } catch (error) {
            console.error('An error occured during login.', error)
            showToastError(this.handleCSCErrorMessage(error))
            return null
          }
        }
        if (!this.id_token) {
          showToastError(this.$t('importCredential.loginError'))
        } else {
          const req = {
            maxResults: 100,
            pageToken: null
          }

          const resp = await csc.listCredentials(providerBaseURL, this.id_token, req)
          this.credentialList = resp.credentialIDs

          const fetchInfoPromises = this.credentialList.map(async (currentID) => {
            const req = {
              credentialID: currentID,
              certInfo: null,
              certificates: 'none'
            }

            const resp = await csc.credentialsInfo(providerBaseURL, this.id_token, req)
            const status = !(resp.key && (resp.key.status === 'disabled'))
            if (status) {
              return {
                id: currentID,
                description: resp.description
              }
            }
            return null
          })

          // this.credentialsInfoArray = await Promise.all(fetchInfoPromises)
          this.credentialsInfoArray = (await Promise.all(fetchInfoPromises)).filter(info => info !== null)
          // externalProviderCredentialsTitle
          this.startPage = false
          this.tab = 'credentials'
        }
      } else {
        if (this.selectedProvider && this.selectedCredentials.length > 0) {
          const submitPromises = this.selectedCredentials.map(async id => {
            const credentialRefDto = {
              provider: this.selectedProvider.id,
              credentialId: id,
              authentication: this.id_token
            }
            const credentialRef = await credentialRefs.createCredentialRef(credentialRefDto)
            this.startPage = true
            eventBus.$emit('refreshCredentials')
            return credentialRef
          })

          try {
            const results = await Promise.all(submitPromises)
            showToastSuccess(this.$t('importCredential.importSucces'))
            this.$router.go(-1)
          } catch (error) {
            showToastError(this.$t('importCredential.importError'))
            console.error('An error occured during the import.', error)
          }
        } else {
          showToastError(this.$t('importCredential.noCredentialSelectedError'))
        }
      }
    }
  }
}
</script>
<style scoped>
.d-none {
  display: none;
}
.v-btn-back {
  /*width: 187px;*/
  min-width: 60px !important;
}
.v-btn-done {
  /*width: 187px;*/
  min-width: 90px !important;
}
</style>
